<template>
    <div>
    <div class="mainC">
        <ul class="list-group MobileHide">
            <div class="container" style="background: #4d4d4d; font-size: 16px; margin-top: 0px; color: white;">
                <!-- <label style="margin-left: 5px; margin-top: 5px;"><input type="radio" value="-1" v-model="kek"><span style="margin-left: 1px;"> All </span></label>
                <label style="margin-left: 5px;"><input type="radio" value="0" v-model="kek" @click="upL()"><span style="margin-left: 1px;">Not started</span></label>
                <label style="margin-left: 5px;"><input type="radio" value="1" v-model="kek"><span style="margin-left: 1px;">Finished</span></label> -->
                <span style="font-weight: 600; margin-top: 5px; margin-right: 5px;">Balance: {{balance}}</span>
                <p>You can remove your Guess if the game is not started yet (TBD) and receive 80% of points back to your balance.</p>
            </div>
            <div class="" v-for="(game, ind) in gameList" :key="game.id"> 
           <li class="list-group-item game" style="border: none;" v-bind:class="{bbg: ind % 2 == 0}">
            <div class="row">
            <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: game.match.id }}">
            <div class="row">
            <div class="col-1 bodyElement" style="font-weight: 600;">
              <p v-if="game.match.matchStatus.name == 'FT'">{{game.match.matchStatus.name}}</p>
              <p v-else-if="game.match.matchStatus.name == 'FT_PEN'">FT</p>
              <p v-else-if="game.match.matchStatus.name == 'POSTP'">PST</p>
              <p v-else-if="game.match.matchStatus.name == 'NS'">{{game.match.matchTime}}</p>    
              <p v-else-if="game.match.matchStatus.name == 'TBA'">TB</p>    
              <p v-else-if="game.match.matchStatus.name == 'AWARDED'">AWR</p>     
              <p v-else-if="game.match.matchStatus.name == 'CANCL'">CNL</p>  
              <p v-else>{{game.match.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
               <img :src="teamLogo + game.match.team1.id" alt="" style="width: 20px;" > <br> {{game.match.team1.name}}
            </div>
            <div class="col-1 bodyElement">
                <p style="font-size: 16px; margin-top: 5px;">{{game.predictionValue}}</p>
            </div>
            <div class="col bodyElement">
                 <img :src="teamLogo + game.match.team2.id" alt="" style="width: 20px;" > <br> {{game.match.team2.name}}
            </div>
                </div>
            </router-link>
            <div class="col-1  bodyElement" style="text-align: center;">
                <p style="margin-top: 5px;" v-if="game.match.matchStatus.name == 'FT' || game.match.matchStatus.name == 'AET'">
                <span style="color: green; font-weight: 600;" v-if="getNumb(game.calculation) > 0 && game.match.currentScore != game.predictionValue"> Won </span> 
                <span style="color: green; font-weight: 600;" v-else-if="getNumb(game.calculation) > 0 && game.match.currentScore == game.predictionValue"> GREAT</span> 
                <span style="color: red; font-weight: 600;" v-else> Lost </span> </p>
                <p style="font-weight: 600; margin-top: 5px;" v-else>TBD</p>
            </div>
            <div class="col-2 bodyElement">
                <img v-if="game.match.matchStatus.name == 'NS'" src="@/assets/delete.png" style="width: 10px; cursor: pointer; margin-top: 7px;" alt="" @click="removeGame(game.id)">
                <p style="color: #1b1d20; font-weight: 600; margin-top: 5px;" v-else>{{getNumb(game.calculation)}}</p>
            </div>
        </div>
            </li>   
            </div>
        </ul>
        <ul class="list-group MobileShow">
            <div class="" style="background: white; font-size: 16px; text-align: right;">
                <!-- <label style="margin-left: 5px; margin-top: 5px;"><input type="radio" value="-1" v-model="kek"><span style="margin-left: 1px;"> All </span></label>
                <label style="margin-left: 5px;"><input type="radio" value="0" v-model="kek" @click="upL()"><span style="margin-left: 1px;">Not started</span></label>
                <label style="margin-left: 5px;"><input type="radio" value="1" v-model="kek"><span style="margin-left: 1px;">Finished</span></label> -->
                <!-- <span style="font-weight: 600; margin-top: 5px; margin-right: 5px;">Balance: {{balance}}</span> -->
            </div>
              <div v-for="(game, ind) in gameList" :key="game.id"> 
           <li class="list-group-item game" style="border: none;" v-bind:class="{bbg: ind % 2 == 0}">
            <div class="row">
            <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: game.match.id }}">
            <div class="row">
            <div class="col-1 mr-3 bodyElement" style="font-weight: 600;">
              <p v-if="game.match.matchStatus.name == 'FT'">{{game.match.matchStatus.name}}</p>
              <p v-else-if="game.match.matchStatus.name == 'FT_PEN'">FT</p>
              <p v-else-if="game.match.matchStatus.name == 'POSTP'">PST</p>
              <p v-else-if="game.match.matchStatus.name == 'NS'">{{game.match.matchTime}}</p>    
              <p v-else-if="game.match.matchStatus.name == 'TBA'">TB</p>    
              <p v-else-if="game.match.matchStatus.name == 'AWARDED'">AWR</p>     
              <p v-else-if="game.match.matchStatus.name == 'CANCL'">CNL</p>  
              <p v-else>{{game.match.matchStatus.name}}</p>  
              </div>
            <div class="col bodyElement">
               <img :src="teamLogo + game.match.team1.id" alt="" style="width: 35px;"> 
            </div>
            <div class="col-1 bodyElement">
                <p style="font-size: 15px; margin-top: 5px;">{{game.predictionValue}}</p>
            </div>
            <div class="col bodyElement">
                 <img :src="teamLogo + game.match.team2.id" alt="" style="width: 35px;">
            </div>
                </div>
            </router-link>
            <div class="col-1 ml-0 bodyElement" style="text-align: center;">
               <p style="margin-top: 5px;" v-if="game.match.matchStatus.name == 'FT' || game.match.matchStatus.name == 'AET'">
                <span style="color: green; font-weight: 600;" v-if="getNumb(game.calculation) > 0 && game.match.currentScore != game.predictionValue"> Won </span> 
                <span style="color: green; font-weight: 600;" v-else-if="getNumb(game.calculation) > 0 && game.match.currentScore == game.predictionValue"> GREAT</span> 
                <span style="color: red; font-weight: 600;" v-else> Lost </span> </p>
                <p style="font-weight: 600; margin-top: 5px;" v-else>TBD</p>
            </div>
            <div class="col-2 bodyElement">
                <img v-if="game.match.matchStatus.name == 'NS'" src="@/assets/delete.png" style="width: 10px; cursor: pointer; margin-top: 7px;" alt="" @click="removeGame(game.id)">
                <p style="color: #1b1d20; font-weight: 600; margin-top: 5px;" v-else>{{getNumb(game.calculation)}}</p>
            </div>
        </div>
            </li>   
            </div>
        </ul>
    </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'PredictionsList',
   data(){
      return{
        gameList: [],
        cookiesObject: '',
        teamLogo: 'https://sportapi.zuniac.com/team/logo/',
        kek: '-1',
        balance: '',
      }
  },
  async beforeMount(){
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    this.upL();
    this.getBalance();
  },

  methods:{
      getNumb(val){
        const sumValues = obj => Object.values(obj).reduce((a, b) => a + b);
        return sumValues(val);
      },
    removeGame(val){
        var myHeaders = new Headers();
            myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

            var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            redirect: 'follow'
            };

            fetch(this.httpReq+'/game/prediction?token='+ this.cookiesObject.token +'&predictionId='+val, requestOptions)
            .then(response => response.json())
            .then(result => {
                alert(result.message);
                this.upL();
                })
            .catch(error => console.log('error', error));
    },
    upL(){
        var myHeaders = new Headers();
        myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        fetch(this.httpReq+'/game/predictions?timezone=%2B04%3A00&predictionResult='+ this.kek +'&token='+ this.cookiesObject.token, requestOptions)
        .then(response => response.json())
        .then(result =>{
            this.gameList = result.gamePredictions;
            })
        .catch(error => console.log('error', error));
    },
    getBalance(){
        var myHeaders = new Headers();
        myHeaders.append("Cookie", "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765");

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        fetch(this.httpReq+"/user/me?token=" + this.cookiesObject.token, requestOptions)
        .then(response => response.json())
        .then(result => {
            this.balance = result.user.score;
        })
        .catch(error => console.log('error', error));
    },
  },
  components: {
   
  },
  computed:{
    ...mapGetters(['httpReq']),
  },
}
</script>

<style scoped>
.bbg{
  background: #f0ecec !important;
}

    .mainC{
    margin-top: 0px;
}

#router-link{
    color: black;
    text-decoration: none;
}

.container{
    margin-top: 12px;
}

li{
   line-height: 18px;
   border-radius: 0px !important;
   font-size: 12px;
}
.LeagueName{
    margin-bottom: 10px;
}

.header{
    background: #d6d6d6;
    color: black;
}

.bodyElement{
    padding: 0;
    height: 28px;
}

.game{
    text-align: center;
}
.game :hover{
    color: #309a3d;
}

@media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}

</style>
